<div class="image">
  <a [href]="link" target="_blank"><img [src]="image?.links?.thumb" /></a>
</div>
